var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { PlayerIntents } from './modules/PlayerIntents';
import { PlayerChannels } from './modules/PlayerChannels';
import { PlayerInfo } from './modules/PlayerInfo';
import { PlayerPlaying } from './modules/PlayerPlaying';
import { memoize } from '../../../utils/mobx/decorators/memoize';
export class MediaPlayer {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get media() {
        return this.parent;
    }
    get app() {
        return this.media.app;
    }
    intents = observable.array();
    get channelVoice() {
        return this.playerChannels.channelVoice;
    }
    get playerIntents() {
        return new PlayerIntents(this);
    }
    get playerChannels() {
        return new PlayerChannels(this);
    }
    get playerInfo() {
        return new PlayerInfo(this);
    }
    get playerPlaying() {
        return new PlayerPlaying(this);
    }
}
__decorate([
    observable.shallow
], MediaPlayer.prototype, "intents", void 0);
__decorate([
    memoize
], MediaPlayer.prototype, "playerIntents", null);
__decorate([
    memoize
], MediaPlayer.prototype, "playerChannels", null);
__decorate([
    memoize
], MediaPlayer.prototype, "playerInfo", null);
__decorate([
    memoize
], MediaPlayer.prototype, "playerPlaying", null);
